module.exports = __webpack_public_path__ + "static/media/remove-duplicates-icon.6777471a.svg";